export default {
  h1: {
    ru: 'Попробуйте 30-дневную бесплатную версию омниканальной платформы для коммуникаций с&nbsp;клиентами на&nbsp;местах продаж',
    en: 'Create your own omni-channel platform',
    cn: '创建您自己的全渠道平台'
  },
  p: {
    ru: 'Заполните форму, и у вас появится своя платформа для управления цифровой рекламой в магазинах, банках, кафе и других местах продаж.',
    en: 'Fill out the&nbsp;form and&nbsp;you will have your own platform for&nbsp;Digital Signage management in&nbsp;stores, banks, cafés and&nbsp;other points of&nbsp;sale.',
    cn: '只需填写此表格，您就能拥有自己的平台，用于在门店、银行、咖啡厅及其他销售点管理数字标牌。'
  },
  h3: {
    ru: 'Вы сможете:',
    en: 'You will be able to:',
    cn: '您可以：'
  },
  copy: {
    ru: '2019 Addreality © Интерактивная платформа для&nbsp;коммуникации с&nbsp;клиентами на&nbsp;местах продаж. Все права защищены. ',
    en: '2019 Addreality © New level of&nbsp;customer experience. Interactive platform for&nbsp;digital signage management. All rights reserved. ',
    cn: '2019 Addreality © 全新的客户体验。数字标牌管理 互动平台。保留所有权利。'
  },
  icp: {
    ru: '沪ICP备17019751-2号',
    en: '沪ICP备17019751-2号',
    cn: '沪ICP备17019751-2号'
  },
  li1: {
    ru: 'Централизованно управлять контентом, оборудованием и интерактивными механиками взаимодействия',
    en: 'Create and&nbsp;centrally manage content and&nbsp;digital media, automate update of&nbsp;advertising POSm',
    cn: '创建并集中管理内容和数字媒体，自动更新销售点广告宣传材料'
  },
  li2: {
    ru: 'Показывать таргетированную рекламу целевой аудитории, используя данные, собираемые в режиме реального времени',
    en: 'Communicate with&nbsp;customers and&nbsp;collect data about your audience, making them buy more',
    cn: '与客户交流，收集观众数据，促使客户增加消费'
  },
  li3: {
    ru: 'Собирать данные об аудитории и эффективности контента, повышать конверсию и оптимизировать рекламные бюджеты',
    en: 'Analyze the&nbsp;effectiveness of&nbsp;your content and&nbsp;interactive mechanics, making A/B tests and&nbsp;changing the&nbsp;content if&nbsp;needed',
    cn: '分析内容和互动机制效果，进行A/B测试，在需要时更改内容'
  },
  country: {
    ru: 'RU',
    en: 'US',
    cn: '美国'
  },
  domainName: {
    ru: 'http://addreality.ru',
    en: 'https://addreality.com',
    cn: 'http://addreality.cn'
  },
  domain: {
    ru: 'Адрес платформы (домен)',
    en: 'Platform address',
    cn: '平台地址'
  },
  domainError: {
    ru: 'Адрес занят',
    en: 'Address not available',
    cn: '地址不可用'
  },
  email: {
    ru: 'E-mail',
    en: 'E-mail',
    cn: '电子邮件'
  },
  useCorporateEmail: {
    ru: 'Используйте email вашей организации',
    en: 'Use email of your organization',
    cn: '使用公司电子邮件地址'
  },
  domainDesc: {
    ru: 'Выберите домен третьего уровня. После регистрации ваша платформа будет доступна по&nbsp;данной ссылке.',
    en: 'Select the&nbsp;third-level domain. After the&nbsp;registration your platform will be&nbsp;available by&nbsp;this link.',
    cn: '选择三级域名。注册成功后，即可通过此链接访问您的平台。'
  },
  // terms: {
  //   ru: 'Нажимая кнопку <b>"Регистрация"</b>, вы принимаете условия <u>пользовательского соглашения</u>',
  //   en: 'By clicking on <b>«registration»</b>, you are accepting terms and conditions of <u>user agreement</u>',
  //   cn: '点击<b>“注册”</b>，即代表您同意<u>用户协议</u>中的条款和条件'
  // },
  clickBtn: {
    ru: 'Нажимая кнопку ',
    //en: 'By clicking on '
    en: '',
    //cn: '点击'
    cn: ''
  },
  terms: {
    ru: ' я подтверждаю свое согласие с ',
    //en: ', you are accepting terms and conditions of '
    en: '',
    //cn: '点击',
    cn: ''
  },
  after_terms: {
    ru: ' в отношении использования сайта, а также принимаю условия <a href="http://www.addreality.ru/eula/" target="_blank">Пользовательского соглашения</a> на использование программного обеспечения "AddReality sphere" и даю свое согласие ООО "Эддреалити" на обработку моих персональных данных в соответствии с законодательством РФ, на условиях и для целей, определенных <a href="http://www.addreality.ru/privacypolicy/" target="_blank">Политикой конфиденциальности</a>.',
    en: '',
    cn: ''
  },
  success: {
    ru: '<b>Регистрация прошла успешно.</b><br><br>Письмо для подтверждения отправлено на указанный при регистрации' +
    ' электронный адрес: ',
    en: '<b>The registration was done successfully.</b><br><br>A confirmation email was sent to the required email address: ',
    cn: '<b>注册成功。</b><br><br>确认邮件将会发送至所指定的电子邮件 地址：'
  },
  sucessCont: {
      ru: '<br><br>Для <b>активации</b> и начала использования платформы, пожалуйста, перейдите по ссылке в письме.',
      en: '<br><br>Follow the link to start using the platform.</b>',
    cn: '<br><br>点击链接，开始使用平台。</b>'
  },
  domainErr: {
    ru: 'Только латинские буквы и цифры',
    en: 'Only Latin letters and digits are allowed',
    cn: '只能使用拉丁字母和数字'
  },
  domainLengthErr: {
    ru: 'Необходимо ввести по крайней мере два символа',
    en: 'It must be at least 2 characters',
    cn: ''
  },
  mailErr: {
    ru: 'Введите корректный email',
    en: 'Please enter correct e-mail',
    cn: '请输入正确的电子邮件'
  },
  agreement: {
    ru: 'Пользовательским соглашением',
    //en: 'user agreement'
    en: '',
    //cn: '用户协议'
    cn: ''
  },
  recover: {
    ru: 'Восстановить пароль',
    en: 'Recover password',
    cn: '找回密码'
  },
  afterRecover: {
    ru: 'Письмо с подтверждением отправлено Вам на почту',
    en: 'A confirmation email has been sent to your e-mail',
    cn: '确认邮件已发至您的电子邮箱'
  },

  registration: {
    ru: 'Регистрация',
    en: 'Registration',
    cn: '注册'
  },

  registration_q: {
    ru: 'Регистрация,',
    //en: 'Registration'
    en: '',
    //cn: '注册'
    cn: ''
  },
  lang: {
    ru: 'Ваш язык',
    en: 'Your language',
    cn: '您的语言'
  },
  oldBrowser1: {
    ru: 'Вы пользуетесь устаревшей версией браузера.',
    en: 'You are using an old version of browser',
    cn: '您的浏览器版本过旧',
  },
  oldBrowser2: {
    ru: 'Поэтому многие страницы сайта могут отображаться некорректно.',
    en: 'Therefore many pages of the website can be displayed incorrectly',
    cn: '因此，网站的很多页面可能会显示错误'
  },
  oldBrowser3: {
    ru: 'Пожалуйста, выберите и установите один из современных браузеров.',
    en: 'Please, choose and install one of modern browsers',
    cn: '请安装新版本浏览器'
  }
}



// WEBPACK FOOTER //
// ./src/lang/texts.js